import { combineReducers } from 'redux'
import ProgramsAllReducer from './programs.all.reducer'
import ProgramsItemReducer from './programs.item.reducer'

const ProgramsReducer = combineReducers({
  all: ProgramsAllReducer,
  item: ProgramsItemReducer,
})

export default ProgramsReducer